<template>
  <div id="app">
    <router-view/>
    <simple-modal v-model="this.generalMessage.modal" title="Leer con atención..." :onClose="onCloseGeneralMessage" class="text-center mb-3">
      <template slot="body">
        <!-- <font-awesome-icon class="text-center" icon="info" size="5x" :style="{...colorSuccess}"/> -->
        <h2 class="text-center">Presione el botón para cerrar</h2>
        <p>{{this.generalMessage.text}}</p>
        <button :style="{...colorButtonSecondary}"  type="button" class="btn btn-primary btn-lg btn-block" v-on:click="onCloseGeneralMessage">
          ACEPTAR
        </button>
      </template>
      <template slot="footer">

      </template>
    </simple-modal>
    <simple-modal v-model="this.generalError" title="Ocurrio un error..." :onClose="onClose" class="text-center mb-3">
      <template slot="body">
        <font-awesome-icon class="text-center" icon="times-circle" size="5x" :style="{...colorError}"/>
        <h2 class="text-center">Presione el boton o espere unos segundos...</h2>
        <button :style="{...colorButtonSecondary}"  type="button" class="btn btn-primary btn-lg btn-block" v-on:click="onClose">
          ACEPTAR
        </button>
      </template>
      <template slot="footer">

      </template>
    </simple-modal>
  </div>
</template>

<script>

import Vue from 'vue'
import { mapState, mapActions, mapMutations } from "vuex"
import SimpleModal from 'simple-modal-vue'
import './assets/css/index.css'

export default {
  data () {
		return {
			timeoutId: null,
		}
	},
  components: { SimpleModal },
  created() {
    Vue.config.errorHandler = (a, b, c) => {
      this.setGeneralError(true)
      console.error("An app error ocurred", a,b,c)
      this.timeoutId = setTimeout(() => {
        this.onClose()
			}, 5000)

    }
  },
  computed: {
    ...mapState(['generalError', 'generalMessage', 'serviceSelected','clientSelected','routeName','branchFlow','skipHourSelection','branchSelected']),
    created() {
      this.setGeneralMessageTicket({
          show: false,
          text: ""
      })
    },
    colorButtonSecondary() {
			const sett = this.getkioskSettings(this.kioskSettings, 'colorButtonSecondary');
			const setColorText = this.getkioskSettings(this.kioskSettings, 'textColor');

			let style = {};
			if(sett){
				style = {
					'background': sett.vvalue,
					'border-color': sett.vvalue,
					'color': setColorText.value
				};
			}
			return style;
    },
    colorError() {
			const sett = this.getkioskSettings(this.kioskSettings, 'colorError');
			let style = {};
			if(sett){
				style = {
					'color': sett.vvalue
				};
			}
			return style;
    },
    colorSuccess() {
			const sett = this.getkioskSettings(this.kioskSettings, 'colorSuccess');
			let style = {};
			if(sett){
				style = {
					'color': sett.vvalue
				};
			}
			return style;
		},
  },
  methods: {
    ...mapMutations(['RESET_STATE']),
    ...mapActions(['setGeneralError', 'resetCurrentCollectedInfo', 'groupSelect', 'serviceSelect', 'setGeneralMessage', 'setGeneralMessageTicket', 'setGroupIdSelected']),
    getkioskSettings(kioskSettings, prop){
			for(const index in kioskSettings){
				if(kioskSettings[index].vkey == prop){
					return kioskSettings[index];
				}
			}
			return null;
		},
    goToInit(){
      console.log("goToInit App", this.routeName,this.branchFlow,this.skipHourSelection,this.branchSelected);
      const nickname = this.clientSelected.nickname;
      const routeName = this.routeName;
      const branchFlow = this.branchFlow;
      const skipHourSelection = this.skipHourSelection;
      const branchSelected = this.branchSelected;
      if (routeName == 'HomeRemote' || routeName == 'ticketRemote'){
        this.RESET_STATE();
        this.$router.push('/home/'+nickname);
      }else if (routeName == 'Branch') {
        if (branchFlow) {
          if (branchFlow && branchSelected && branchSelected.id && skipHourSelection != null) {
            this.RESET_STATE();
            this.$router.push({name: 'HomeRemote', params: {nickname: nickname}, query :{branchId: branchSelected.id, skipHour: skipHourSelection}}).catch(err => {})
          }else {
            console.log("Error page 2");
            this.$router.push('/error_na/');
          }
        }else{
          this.RESET_STATE();
          this.$router.push('/home/'+nickname);
        }
      }else{
        this.RESET_STATE();
        this.$router.push('/home/'+nickname);
      }
    },
    onClose() {
      if(this.timeoutId) clearTimeout(this.timeoutId)
      this.setGeneralError(false)
      this.resetCurrentCollectedInfo()
      this.serviceSelect(null)
      this.setGroupIdSelected(0)
      this.groupSelect(null)
      if (this.clientSelected && this.clientSelected.nickname){
        this.goToInit()
      }else if(this.routeName !=  ''){
        console.log("Error page");
        this.$router.push('/error_na/');
      } else {
        if(this.$route.path != '/service_selection' && this.$route.path != '/')
          this.$router.push({name: 'ServiceSelection'})
      }
    },
    onCloseGeneralMessage() {
      let groupOrServiceSelected = this.generalMessage.groupOrServiceSelected
      console.log(groupOrServiceSelected)
      if(groupOrServiceSelected) {
        if(groupOrServiceSelected.service) {
          this.setGeneralMessageTicket({
              show: true,
              text: "Antes de acudir a su cita, debe pasar por el área de recaudación. Se le creó un turno para ser atendido en el área de Recaudación",
          })
          this.$router.push({
            name: 'TicketSuccess',
            params: {
              service: groupOrServiceSelected,
              serviceId: groupOrServiceSelected.service.id
            }
          })
        }
      }
      this.setGeneralMessage({
        modal: false,
        text: "",
        service: null,
      })
    }
  }
}
</script>

<style>
.btn-group-lg>.btn, .btn-lg {
  padding: .5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: .3rem;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 1.9rem + 2px);
  padding: .375rem .75rem;
  font-size: 1.2em;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
  font-size: 1.35rem;
}
  
.btn-group-lg>.btn[data-v-168700d8], .btn-lg[data-v-168700d8] {
  padding: 1.5rem 1rem;
  font-size: 1.75rem;
  line-height: 1.5;
  border-radius: 4.0rem;
  box-shadow: 0px 4px 3px 1px rgb(228 228 228 / 1);
}

.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
  margin-bottom: 1.5rem;
  font-weight: 500;
  line-height: 1.2;
}
</style>
